import React from 'react';
import { AppTabs } from 'qcc';
import { default as DeviceGird } from './DeviceGird';
import { default as ProgramGird } from './ProgramGird';
import './index.less'

const tabs: string[] = ['POS设备', 'POS版本'];
export default class extends React.Component<IPage> {
  state = { tabIndex: 0 }

  tabChg = (tabIndex: number) => {
    this.setState({ tabIndex })
  }

  render() {
    return (
      <div className='page-pos-device-container'>
        <AppTabs tabs={tabs} onChange={this.tabChg}></AppTabs>
        <div className='page-device-grid-container'>
          {this.state.tabIndex === 0 ? <DeviceGird /> : <ProgramGird />}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/page/pos/device/index.tsx